export default __webpack_public_path__ + "static/media/logo_sq.da280357.png";